import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'Tutoring in Springfield & Willard, MO | Berkstresser LLC',
      description: 'Berkstresser LLC is a home-based tutoring service offering personalized K-12 and lower-college tutoring in Springfield & Willard, MO, in person or virtually via Zoom.'
    }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/PrivacyView.vue'),
    meta: {
      title: 'Privacy & Terms of Service | Berkstresser LLC',
      description: 'Privacy, data usage, and warranty information for the Berkstresser LLC tutoring website.'
    }
  },
  {
    path: '/about_us',
    name: 'about_us',
    component: () => import('../views/AboutUsView.vue'),
    meta: {
      title: 'About Us | Berkstresser LLC',
      description: 'Meet the Berkstresser LLC tutoring crew: CJ Berkstresser, Caleb Berkstresser, and Kendell Loyd, with over 35 years of combined education experience.'
    }
  },
  {
    path: '/pricing',
    name: 'pricing',
    component: () => import('../views/PricingView.vue'),
    meta: {
      title: 'Pricing | Berkstresser LLC',
      description: 'Simple, transparent tutoring pricing from Berkstresser LLC in Springfield & Willard, MO.'
    }
  },
  {
    path: '/faq',
    name: 'faq',
    component: () => import('../views/FaqView.vue'),
    meta: {
      title: 'FAQ | Berkstresser LLC',
      description: 'Frequently asked questions about Berkstresser LLC tutoring: subjects, grade levels, in-person vs. virtual, scheduling, rates, service area, and how to get started.'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'notfound',
    component: () => import('../views/NotFoundPageView.vue'),
    meta: {
      title: 'Page Not Found | Berkstresser LLC',
      description: 'The page you are looking for could not be found.'
    }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

const DEFAULT_TITLE = 'Berkstresser LLC';
const DEFAULT_DESCRIPTION = 'Berkstresser LLC is a home-based tutoring service in Springfield & Willard, MO, offering personalized K-12 and lower-college tutoring in person or virtually via Zoom.';

router.afterEach((to) => {
  const title = (to.meta && (to.meta.title as string)) || DEFAULT_TITLE;
  const description = (to.meta && (to.meta.description as string)) || DEFAULT_DESCRIPTION;

  document.title = title;

  let tag = document.querySelector('meta[name="description"]');
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', 'description');
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', description);
});

export default router;
